import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Dashboard from "@components/Dashboard";
import GisLaunch from "@components/GisLaunch";
import Content from "@components/partials/Content";

import Provinces from "@metaData/Provinces/Provinces";
import AddProvinces from "@metaData/Provinces/AddProvinces";
import EditProvinces from "@metaData/Provinces/EditProvinces";

import Division from "@metaData/Division/Division";
import AddDivision from "@metaData/Division/AddDivision";
import EditDivisions from "@metaData/Division/EditDivision";

import Districts from "@metaData/District/District";
import AddDistricts from "@metaData/District/AddDistrict";
import EditDistricts from "@metaData/District/EditDistrict";

import RGC from "@metaData/Rgc/RGC";
import AddRGC from "@metaData/Rgc/AddRGC";
import EditRGC from "@metaData/Rgc/EditRGC";

import Union from "@metaData/Union/Union";
import AddUnion from "@metaData/Union/AddUnion";
import EditUnion from "@metaData/Union/EditUnion";

import Features from "@metaData/Features/Features";
import AddFeatures from "@metaData/Features/AddFeatures";
import EditFeatures from "@metaData/Features/EditFeatures";

import FeaturesType from "@metaData/FeaturesType/FeatureTypes";
import AddFeaturesType from "@metaData/FeaturesType/AddFeaturesType";
import EditFeaturesType from "@metaData/FeaturesType/EditFeaturesType";

import FeatureCategoryList from "@metaData/featureCategory/featureCategory";
import AddFeatureCategory from "@metaData/featureCategory/addFeatureCategory";
import EditFeatureCategory from "@metaData/featureCategory/editFeatureCategory";

import Cycles from "@metaData/Cycle/Cycle";
import AddCycle from "@metaData/Cycle/AddCycle";
import EditCycle from "@metaData/Cycle/EditCycle";

import Tehsile from "@metaData/Tehsile/Tehsile";
import AddTehsile from "@metaData/Tehsile/AddTehsile";
import EditTehsile from "@metaData/Tehsile/EditTehsile";

import Deh from "@metaData/deh/Deh";
import AddDeh from "@metaData/deh/AddDeh";
import EditDeh from "@metaData/deh/editDeh";

import Village from "@metaData/Village/Village";
import AddVillage from "@metaData/Village/AddVillage";
import EditVillage from "@metaData/Village/EditVillage";

import Users from "@user/users/Users";
import AddUser from "@user/users/AddUsers";
import EditUsers from "@user/users/EditUsers";
import UpdatePassword from "@user/users/UpdatePassword";
import ChangePassword from "@user/users/ChangePassword";
import GetProfile from "@components/partials/Profile";

import Roles from "@user/roles/Roles";
import AddRoles from "@user/roles/AddRoles";
import EditRoles from "@user/roles/EditRoles";

import Groups from "@user/groups/Groups";
import AddGroups from "@user/groups/AddGroups";
import EditGroups from "@user/groups/EditGroups";

import Permissions from "@user/permissions/Permissions";
// import AddPermissions from "@user/permissions/AddPermission";
// import EditPermissions from "@user/permissions/EditPermission";

import ManagePermissions from "@user/managepermissions/Permissions";
import AddPermissions from "@user/managepermissions/AddPermission";
import EditPermissions from "@user/managepermissions/EditPermissions";

import HouseHold from "@household/HouseHold";
import EditHouse from "@household/EditHouse";

import ProposedFeaturesList from "@proposedBOQs/ProposedFeaturesList";
import ManageBOQs from "@proposedBOQs/ManageBOQs";

import SmeGrantList from "@grants/smeGrant/SmeGrantList";
import AddSmeGrant from "@grants/smeGrant/AddSmeGrant";
import EditSmeGrant from "@grants/smeGrant/EditSmeGrant";

import MicroGrantList from "@grants/microGrant/MicroGrantList";
import AddMicroGrant from "@grants/microGrant/AddMicroGrant";
import EditMicroGrant from "@grants/microGrant/EditMicroGrant";

import GrantsDocs from "@grants/GrantsDocs";

import Wash from "@wash/Wash";
import EditWash from "@wash/EditWash";

import ImplementationPhase from "../components/implementationPhase/ImplementationListing.jsx";
import ViewImplementation from "../components/implementationPhase/viewImplementation/ViewImplementation.jsx";

import Login from "@auth/Login";
import NotFound from "@common/404Page";
import PrivacyPolicy from "@common/PrivacyPolicy";
import SchoolAssessment from "../components/SchoolAssessment/SchoolAssessment";
// import BasicSchoolProfile from "../components/SchoolAssessment/BasicSchoolProfile";
// import InfrastructureForm from "../components/SchoolAssessment/InfrastructureForm";
// import LearningFacilities from "../components/SchoolAssessment/LearningFacilities";
// import AdministrativeCommunity from "../components/SchoolAssessment/AdministrativeCommunity";
import SchoolAssessments from "../components/SchoolAssessment/SchoolAssessments";
// import HealthFacility from "../components/HealthFacility/HealthFacility";
// import GeneralInformation from "../components/HealthFacility/GeneralInformation";
// import InfrastructureEnvironment from "../components/HealthFacility/InfrastructureEnvironment";
// import EssentialServices from "../components/HealthFacility/EssentialServices";
import HealthFacilityAssessment from "../components/HealthFacility/HealthFacilityAssessment";
import HealthFacilityAssessmentsListing from "../components/HealthFacility/HealthFacilityAssessmentsListing";
import ImplementationPhaseFeatuesList from "../components/implementationPhase/ImplementationPhaseFeatuesList.jsx";

import MonitoringPhaseListing from "../components/monitoringPhase/MonitoringPhaseListing";
import ViewMonitoring from "../components/monitoringPhase/ViewMonitoring";

import MPIStandard from "@metaData/MPIStandard/MPIStandard";
import MPIHousehold from "../components/MPI/MPIHousehold";
import MPIVillage from "../components/MPI/MPIVillage";

import Unauthorized from "@common/Unauthorized";
import PermissionRoute from "@common/PermissionRoute.jsx";

// src\components\metaData\Features

// import AddDeh from "../components/metaData/deh/AddDeh";

// import EditOtherPublic from "../components/OtherPublic/Summarized/EditOtherPublic";
// import ViewOtherPublic from "../components/OtherPublic/Summarized/ViewOtherPublic";

// Wrapper component for protecting routes
const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem("token");
  return token ? element : <Navigate to="/login" replace />;
};

/*************  ✨ Codeium Command ⭐  *************/
/**
 * AppRouter component. This component is responsible for routing the application.
 *
 * This component uses the `Routes` component from `react-router-dom` to define the routes
 * for the application. The routes are defined as a nested array of `Route` components.
 *
 * The first `Route` component is for the login page. It renders the `Login` component if
 * the user is not logged in. If the user is logged in, it redirects to the home page.
 *
 * 
 * 

/******  e2341044-a14e-4a31-a00c-b7b5abb04536  *******/

const AppRouter = () => {
  const token = localStorage.getItem("token");

  const loading = useSelector((state) => state);

  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];

  return (
    <>
      <Routes>
        {/* Redirect to / if token exists */}
        <Route
          path="/login"
          element={token ? <Navigate to="/" replace /> : <Login />}
        />

        {/* Handles its own login redirect so the user can return to GIS afterwards */}
        <Route path="/gis-launch" element={<GisLaunch />} />

        {/*Privacy Policy*/}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/*404 page route*/}
        <Route path="*" element={<NotFound />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute element={<Dashboard />} />}>
          <Route path="/" element={<Content />} />
          <Route path="provinces" element={<Provinces />} />
          <Route path="provinces/edit/:id" element={<EditProvinces />} />
          <Route path="provinces/add" element={<AddProvinces />} />

          <Route
            path="/features"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-view"
                showMessage={false}
              >
                <Features />
              </PermissionRoute>
            }
          />
          <Route
            path="/features/add"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-create"
                showMessage={false}
              >
                <AddFeatures />
              </PermissionRoute>
            }
          />
          <Route
            path="/features/edit/:id"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-update"
                showMessage={false}
              >
                <EditFeatures />
              </PermissionRoute>
            }
          />

          <Route
            path="/subtypes"
            // element={<FeaturesType />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-sub-type-view"
                showMessage={false}
              >
                <FeaturesType />
              </PermissionRoute>
            }
          />
          <Route
            path="/subtypes/add"
            //  element={<AddFeaturesType />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-sub-type-create"
                showMessage={false}
              >
                <AddFeaturesType />
              </PermissionRoute>
            }
          />
          <Route
            path="/subtypes/edit/:id"
            // element={<EditFeaturesType />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-sub-type-update"
                showMessage={false}
              >
                <EditFeaturesType />
              </PermissionRoute>
            }
          />

          <Route
            path="/feature-category-view"
            // element={<FeatureCategoryList />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-category-view"
                showMessage={false}
              >
                <FeatureCategoryList />
              </PermissionRoute>
            }
          />
          <Route
            path="/feature-category-view/add"
            // element={<AddFeatureCategory />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-category-create"
                showMessage={false}
              >
                <AddFeatureCategory />
              </PermissionRoute>
            }
          />
          <Route
            path="/feature-category-edit/:id"
            // element={<EditFeatureCategory />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="feature-category-update"
                showMessage={false}
              >
                <EditFeatureCategory />
              </PermissionRoute>
            }
          />

          <Route
            path="/cycles"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="cycle-view"
                showMessage={false}
              >
                <Cycles />
              </PermissionRoute>
            }
          />
          <Route
            path="/cycles/add"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="cycle-create"
                showMessage={false}
              >
                <AddCycle />
              </PermissionRoute>
            }
          />
          <Route
            path="/cycles/edit/:id"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="cycle-update"
                showMessage={false}
              >
                <EditCycle />
              </PermissionRoute>
            }
          />

          <Route
            path="mpi-standard"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="mpi-standard-view"
                showMessage={false}
              >
                <MPIStandard />
              </PermissionRoute>
            }
          />
          {/* MPI Household */}
          <Route
            path="mpi-household"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="mpi-household-view"
                showMessage={false}
              >
                <MPIHousehold />
              </PermissionRoute>
            }
          />

          {/* MPI Village */}
          <Route
            path="mpi-village"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="mpi-village-view"
                showMessage={false}
              >
                <MPIVillage />
              </PermissionRoute>
            }
          />
          {/* centers */}
          <Route
            path="dehs"
            // element={<Deh />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="deh-view"
                showMessage={false}
              >
                <Deh />
              </PermissionRoute>
            }
          />
          <Route
            path="dehs/add"
            //  element={<AddDeh />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="deh-create"
                showMessage={false}
              >
                <AddDeh />
              </PermissionRoute>
            }
          />
          <Route
            path="/dehs/edit/:id"
            // element={<EditDeh />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="deh-update"
                showMessage={false}
              >
                <EditDeh />
              </PermissionRoute>
            }
          />

          {/* Village */}
          <Route
            path="villages"
            // element={<Village />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="village-view"
                showMessage={false}
              >
                <Village />
              </PermissionRoute>
            }
          />
          <Route
            path="villages/add"
            // element={<AddVillage />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="village-create"
                showMessage={false}
              >
                <AddVillage />
              </PermissionRoute>
            }
          />
          <Route
            path="villages/edit/:id"
            // element={<EditVillage />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="village-update"
                showMessage={false}
              >
                <EditVillage />
              </PermissionRoute>
            }
          />

          {/* divisions */}
          <Route
            path="divisions"
            // element={<Division />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="divisions-view"
                showMessage={false}
              >
                <Division />
              </PermissionRoute>
            }
          />
          <Route
            path="divisions/add"
            // element={<AddDivision />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="divisions-create"
                showMessage={false}
              >
                <AddDivision />
              </PermissionRoute>
            }
          />
          <Route
            path="divisions/edit/:id"
            // element={<EditDivisions />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="divisions-update"
                showMessage={false}
              >
                <EditDivisions />
              </PermissionRoute>
            }
          />

          {/* district */}
          <Route
            path="districts"
            // element={<Districts />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="district-view"
                showMessage={false}
              >
                <Districts />
              </PermissionRoute>
            }
          />
          <Route
            path="districts/add"
            // element={<AddDistricts />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="district-create"
                showMessage={false}
              >
                <AddDistricts />
              </PermissionRoute>
            }
          />
          <Route
            path="districts/edit/:id"
            // element={<EditDistricts />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="district-update"
                showMessage={false}
              >
                <EditDistricts />
              </PermissionRoute>
            }
          />

          <Route
            path="rgcs"
            // element={<RGC />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="rgc-view"
                showMessage={false}
              >
                <RGC />
              </PermissionRoute>
            }
          />
          <Route
            path="rgcs/add"
            // element={<AddRGC />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="rgc-create"
                showMessage={false}
              >
                <AddRGC />
              </PermissionRoute>
            }
          />
          <Route
            path="rgcs/edit/:id"
            // element={<EditRGC />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="rgc-update"
                showMessage={false}
              >
                <EditRGC />
              </PermissionRoute>
            }
          />

          {/* Tehsile */}
          <Route
            path="tehsils"
            // element={<Tehsile />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="tehsil-view"
                showMessage={false}
              >
                <Tehsile />
              </PermissionRoute>
            }
          />
          <Route
            path="tehsils/add"
            // element={<AddTehsile />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="tehsil-create"
                showMessage={false}
              >
                <AddTehsile />
              </PermissionRoute>
            }
          />

          <Route
            path="tehsils/edit/:id"
            // element={<EditTehsile />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="tehsil-update"
                showMessage={false}
              >
                <EditTehsile />
              </PermissionRoute>
            }
          />
          {/* UCS */}
          <Route
            path="ucs"
            // element={<Union />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="ucs-view"
                showMessage={false}
              >
                <Union />
              </PermissionRoute>
            }
          />
          <Route
            path="ucs/add"
            // element={<AddUnion />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="ucs-create"
                showMessage={false}
              >
                <AddUnion />
              </PermissionRoute>
            }
          />
          <Route
            path="ucs/edit/:id"
            //  element={<EditUnion />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="ucs-update"
                showMessage={false}
              >
                <EditUnion />
              </PermissionRoute>
            }
          />

          {/* users */}
          <Route
            path="users"
            // element={<Users />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="user-view"
                showMessage={false}
              >
                <Users />
              </PermissionRoute>
            }
          />
          <Route
            path="users/add"
            // element={<AddUser />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="user-create"
                showMessage={false}
              >
                <AddUser />
              </PermissionRoute>
            }
          />
          <Route
            path="users/edit/:id"
            // element={<EditUsers />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="user-update"
                showMessage={false}
              >
                <EditUsers />
              </PermissionRoute>
            }
          />
          <Route
            path="users/update-password/:id"
            // element={<UpdatePassword />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="user-update-password"
                showMessage={false}
              >
                <UpdatePassword />
              </PermissionRoute>
            }
          />
          <Route path="/profile" element={<GetProfile />} />

          <Route
            path="users/change-password"
            // element={<ChangePassword />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="user-change-password"
                showMessage={false}
              >
                <ChangePassword />
              </PermissionRoute>
            }
          />

          {/* roles */}
          <Route
            path="roles"
            //  element={<Roles />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="role-view"
                showMessage={false}
              >
                <Roles />
              </PermissionRoute>
            }
          />
          <Route
            path="roles/add"
            // element={<AddRoles />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="role-create"
                showMessage={false}
              >
                <AddRoles />
              </PermissionRoute>
            }
          />
          <Route
            path="roles/edit/:id"
            // element={<EditRoles />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="role-update"
                showMessage={false}
              >
                <EditRoles />
              </PermissionRoute>
            }
          />

          {/* groups */}
          <Route
            path="groups"
            // element={<Groups />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="group-view"
                showMessage={false}
              >
                <Groups />
              </PermissionRoute>
            }
          />
          <Route
            path="groups/add"
            //  element={<AddGroups />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="group-create"
                showMessage={false}
              >
                <AddGroups />
              </PermissionRoute>
            }
          />
          <Route
            path="groups/edit/:id"
            // element={<EditGroups />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="group-update"
                showMessage={false}
              >
                <EditGroups />
              </PermissionRoute>
            }
          />

          {/* permissions */}
          <Route
            path="permissions"
            // element={<Permissions />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="permission-view"
                showMessage={false}
              >
                <Permissions />
              </PermissionRoute>
            }
          />
          {/* <Route path="permissions/add" element={<AddPermissions />} />
          <Route path="permissions/edit" element={<EditPermissions />} /> */}

          {/* Manage permissions */}
          <Route path="manage-permissions" element={<ManagePermissions />} />
          <Route
            path="manage-permissions/add"
            //  element={<AddPermissions />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="permission-create"
                showMessage={false}
              >
                <AddPermissions />
              </PermissionRoute>
            }
          />
          <Route
            path="manage-permissions/edit/:id"
            // element={<EditPermissions />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="permission-update"
                showMessage={false}
              >
                <EditPermissions />
              </PermissionRoute>
            }
          />

          {/* NFE */}
          {/* WiseDetails */}

          {/* users */}
          {/* <Route path="users" element={<Users />} />
          <Route path="users/add" element={<AddUser />} />
          <Route path="users/edit/:id" element={<EditUsers />} /> */}

          {/* roles */}
          {/* <Route path="roles" element={<Roles />} />
          <Route path="roles/add" element={<AddRoles />} />
          <Route path="roles/edit/:id" element={<EditRoles />} /> */}

          {/* groups */}
          {/* <Route path="groups" element={<Groups />} />
          <Route path="groups/add" element={<AddGroups />} />
          <Route path="groups/edit" element={<EditGroups />} /> */}

          {/* permissions
          <Route path="permissions" element={<Permissions />} />
          <Route path="permissions/add" element={<AddPermissions />} />
          <Route path="permissions/edit" element={<EditPermissions />} /> */}

          {/* houseHold */}
          {/* <Route
            permissions={permissions?.includes("household-information-view")}
            path="household"
            element={<HouseHold />}
          /> */}

          <Route
            path="household"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="household-information-view"
                showMessage={false}
              >
                <HouseHold />
              </PermissionRoute>
            }
          />

          <Route
            path="household/edit/:id"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="household-information-update"
              >
                <EditHouse />
              </PermissionRoute>
            }
          />

          {/* wash */}
          <Route
            path="wash"
            // element={<Wash />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="wash-information-view"
              >
                <Wash />
              </PermissionRoute>
            }
          />

          <Route
            path="wash/edit/:id"
            // element={<EditWash />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="wash-information-update"
              >
                <EditWash />
              </PermissionRoute>
            }
          />

          <Route
            path="proposed-features"
            // element={<ProposedFeaturesList />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="infrastructure-information-view"
              >
                <ProposedFeaturesList />
              </PermissionRoute>
            }
          />

          <Route
            path="proposed-features/add"
            // element={<ManageBOQs />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="infrastructure-information-create"
              >
                <ManageBOQs />
              </PermissionRoute>
            }
          />

          <Route
            path="proposed-features/manage/:villageId"
            // element={<ManageBOQs />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="infrastructure-information-update"
              >
                <ManageBOQs />
              </PermissionRoute>
            }
          />

          <Route
            path="sme-grant"
            // element={<SmeGrantList />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="sme-grant-view"
              >
                <SmeGrantList />
              </PermissionRoute>
            }
          />
          <Route
            path="sme-grant/add"
            //  element={<AddSmeGrant />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="sme-grant-create"
              >
                <AddSmeGrant />
              </PermissionRoute>
            }
          />
          <Route
            path="sme-grant/edit/:id"
            // element={<EditSmeGrant />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="sme-grant-update"
              >
                <EditSmeGrant />
              </PermissionRoute>
            }
          />

          {/* Corporate Grant Routes — reuses SmeGrant components, distinguished by grant_type */}
          <Route
            path="corporate-grant"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="corporate-grant-view"
              >
                <SmeGrantList grantType="corporate" />
              </PermissionRoute>
            }
          />
          <Route
            path="corporate-grant/add"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="corporate-grant-create"
              >
                <AddSmeGrant grantType="corporate" />
              </PermissionRoute>
            }
          />
          <Route
            path="corporate-grant/edit/:id"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="corporate-grant-update"
              >
                <EditSmeGrant grantType="corporate" />
              </PermissionRoute>
            }
          />

          {/* Social Enterprise Grant Routes — reuses SmeGrant components, distinguished by grant_type */}
          <Route
            path="social-enterprise-grant"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="social-enterprise-grant-view"
              >
                <SmeGrantList grantType="social-enterprise" />
              </PermissionRoute>
            }
          />
          <Route
            path="social-enterprise-grant/add"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="social-enterprise-grant-create"
              >
                <AddSmeGrant grantType="social-enterprise" />
              </PermissionRoute>
            }
          />
          <Route
            path="social-enterprise-grant/edit/:id"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="social-enterprise-grant-update"
              >
                <EditSmeGrant grantType="social-enterprise" />
              </PermissionRoute>
            }
          />

          {/* SEDF Enterprise Grant Routes — reuses SmeGrant components, distinguished by grant_type */}
          <Route
            path="sedf-enterprise-grant"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="sedf-enterprise-grant-view"
              >
                <SmeGrantList grantType="sedf-enterprise" />
              </PermissionRoute>
            }
          />
          <Route
            path="sedf-enterprise-grant/add"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="sedf-enterprise-grant-create"
              >
                <AddSmeGrant grantType="sedf-enterprise" />
              </PermissionRoute>
            }
          />
          <Route
            path="sedf-enterprise-grant/edit/:id"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="sedf-enterprise-grant-update"
              >
                <EditSmeGrant grantType="sedf-enterprise" />
              </PermissionRoute>
            }
          />

          {/*Implementation Phase Routes */}
          <Route
            path="implementation-phase"
            // element={<ImplementationPhase />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="implementation-phase-view"
              >
                <ImplementationPhase />
              </PermissionRoute>
            }
          />
          <Route
            path="implementation-phase/manage/:village_id"
            // element={<ImplementationPhaseFeatuesList />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="implementation-phase-update"
              >
                <ImplementationPhaseFeatuesList />
              </PermissionRoute>
            }
          />
          <Route
            path="implementation-phase/manage/:village_id/feature/:boqs_proposed_id"
            // element={<ViewImplementation />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="implementation-phase-update"
              >
                <ViewImplementation />
              </PermissionRoute>
            }
          />

          {/* Monitoring Phase Routes */}
          <Route
            path="monitoring-phase"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="monitoring-phase-view"
              >
                <MonitoringPhaseListing />
              </PermissionRoute>
            }
          />
          <Route
            path="monitoring-phase/view/:boqs_proposed_monitoring_id"
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="monitoring-phase-view"
              >
                <ViewMonitoring />
              </PermissionRoute>
            }
          />

          {/* Micro Grant Routes */}
          <Route
            path="micro-grant"
            // element={<MicroGrantList />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="micro-grant-view"
              >
                <MicroGrantList />
              </PermissionRoute>
            }
          />
          <Route
            path="micro-grant/add"
            // element={<AddMicroGrant />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="micro-grant-create"
              >
                <AddMicroGrant />
              </PermissionRoute>
            }
          />
          <Route
            path="micro-grant/edit/:id"
            //  element={<EditMicroGrant />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="micro-grant-update"
              >
                <EditMicroGrant />
              </PermissionRoute>
            }
          />

          <Route
            path="useful-attachments"
            // element={<GrantsDocs />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="grants-attachment-view"
              >
                <GrantsDocs />
              </PermissionRoute>
            }
          />

          {/* SchoolAssessment */}
          <Route
            path="schoolassessment"
            // element={<SchoolAssessment />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="school-assessment-view"
              >
                <SchoolAssessment />
              </PermissionRoute>
            }
          />
          {/* <Route path="basicschoolprofile" element={<BasicSchoolProfile />} />
               <Route path="infrastructureform" element={<InfrastructureForm />} />
               <Route path="learningfacilities" element={<LearningFacilities />} />
               <Route path="administrativecommunity" element={<AdministrativeCommunity />} /> */}
          <Route path="schoolassessments" element={<SchoolAssessments />} />
          <Route
            path="school-assessment/edit/:id"
            // element={<SchoolAssessments />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="school-assessment-update"
              >
                <SchoolAssessments />
              </PermissionRoute>
            }
          />
          {/* <Route path="healthfacility" element={<HealthFacility />} />
               <Route path="generalinformation" element={<GeneralInformation />} />
               <Route path="infrastructureenvironment" element={<InfrastructureEnvironment />} />
               <Route path="essentialservices" element={<EssentialServices />} /> */}
          <Route
            path="healthfacilityassessment"
            // element={<HealthFacilityAssessmentsListing />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="health-facility-assessment-view"
              >
                <HealthFacilityAssessmentsListing />
              </PermissionRoute>
            }
          />
          <Route
            path="healthfacilityassessment/edit/:id"
            // element={<HealthFacilityAssessment />}
            element={
              <PermissionRoute
                permissions={permissions}
                requiredPermission="health-facility-assessment-update"
              >
                <HealthFacilityAssessment />
              </PermissionRoute>
            }
          />
        </Route>

        {/* Unauthorized route */}
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </>
  );
};

export default AppRouter;
